/* eslint-disable @typescript-eslint/no-explicit-any */
export class BdoService {

  static getErrorText(error: any): string{
    return error.error.message;
  }
}
